(function () {
    'use strict';
    /*
     * Copyright (c) 2017-19 In Hand Health.
     * All rights reserved.
     */

    /**
     * The controller for the glance tab of the campaign page.
     */
    angular
        .module('ihh-common-web')
        .controller('CampaignGlanceCtrl', CampaignGlanceCtrl);

    CampaignGlanceCtrl.$inject = ['$scope', '$routeParams', 'Utilities', 'RestResources', '_', 'ProtocolChooserConfig',
        'ObserverService', 'CampaignConstants', 'IhhModalItemChooser',
        'EpisodeTemplateService', 'CampaignGlanceConstants', 'IhhArrays', 'I18nService'];

    function CampaignGlanceCtrl ($scope, $routeParams, Utilities, RestResources, _, ProtocolChooserConfig,
        ObserverService, CampaignConstants, IhhModalItemChooser,
        EpisodeTemplateService, CampaignGlanceConstants, IhhArrays, I18nService) {
        var vm = this;
        var confirmAwaySetup = false;

        // We may or may not be in the context of a clinic.  If so, caller must make sure that clinic and clinic group are filled
        // out so that values such as available episode types can be extracted.
        var clinicGroupId = vm.clinic && vm.clinic.clinicGroup ? vm.clinic.clinicGroup.id : null;

        var campaignId = $routeParams.campaignId;

        vm.pageStrings = I18nService.pages.campaignGlance;

        vm.isEdit = false;
        vm.chooseProtocol = chooseProtocol;
        vm.chooseTherapist = chooseTherapist;
        vm.removeProtocol = removeProtocol;
        vm.removeTherapist = removeTherapist;
        vm.isCareGroupsFeatureEnabled = isCareGroupsFeatureEnabled;
        vm.chooseCareGroup = chooseCareGroup;
        vm.removeCareGroup = removeCareGroup;
        vm.isVirtualVisitsFeatureEnabled = isVirtualVisitsFeatureEnabled;
        vm.getVirtualVisitsAllowed = getVirtualVisitsAllowed;
        vm.setVirtualVisitsAllowed = setVirtualVisitsAllowed;
        vm.formatVirtualVisitsAllowed = formatVirtualVisitsAllowed;

        vm.chooseAssociate = chooseAssociate;
        vm.removeAssociate = removeAssociate;

        vm.formatEpisodeType = formatEpisodeType;
        vm.getEpisodeType = getEpisodeType;
        vm.setEpisodeType = setEpisodeType;
        vm.getEpisodeTypes = getEpisodeTypes;
        vm.showEpisodeType = showEpisodeType;

        /**
         * If the caller provides a clinic feature flag function use it; otherwise no features are on.
         * @returns {Boolean} whether the enable the clinic feature
         */
        var hasClinicFeature = vm.hasClinicFeature || function() {
            return false;
        };

        vm.glance;
        vm.glanceTemp;

        activate();

        function activate() {
            registerObserverCallback();

            vm.glance = angular.copy(vm.episodeModel);
            vm.glance.careGroups = vm.glance.careGroups || [];

            if (!vm.glance.id) {
                edit();
            }

            if (vm.clinic) {
                vm.episodeTypes = vm.clinic.clinicSpecialty ? vm.clinic.clinicSpecialty.episodeTypes : null;
            }
            else {
                RestResources.getEpisodeTypesResource().query({}, function(result) {
                    vm.episodeTypes = result.items;
                });
            }

            var unwatchFormInit = $scope.$watch(CampaignConstants.form.campaignGlanceForm, function(theForm) {
                if (theForm) {
                    unwatchFormInit();
                    ObserverService.notifyObservers(CampaignConstants.observers.form.formReady, vm.campaignGlanceForm);
                }
            });
        }

        function chooseProtocol() {
            var config = ProtocolChooserConfig.init(vm.therapistId, vm.clinic.id, clinicGroupId, false, function(protocol) {
                vm.glanceTemp.protocol = protocol;
                setDirty();
            });
            config.maintainState($scope);

            IhhModalItemChooser.open(config, true);
        }

        function removeProtocol() {
            vm.glanceTemp.protocol = '';
            setDirty();
        }

        function chooseTherapist() {
            if (vm.therapistConfig) {
                vm.therapistConfig.setSuppressedItems(vm.glanceTemp.therapists);
                vm.therapistConfig.setSelectedFn(function(item) {
                    addTherapist(item);
                });

                vm.therapistConfig.maintainState($scope);
                vm.therapistConfig.setDirty(true);
                vm.therapistConfig.nextPage();

                IhhModalItemChooser.open(vm.therapistConfig);
            }
        }

        function addTherapist(therapist) {
            IhhArrays.addWithNoDup(vm.glanceTemp.therapists, therapist);
        }

        function removeTherapist(therapist) {
            for (var i = 0; i < vm.glanceTemp.therapists.length; i++) {
                if (vm.glanceTemp.therapists[i].id === therapist.id) {
                    vm.glanceTemp.therapists.splice(i, 1);
                }
            }
        }

        function chooseAssociate() {
            if (vm.associateConfig) {
                vm.associateConfig.setSuppressedItems(vm.glanceTemp.associates);
                vm.associateConfig.setSelectedFn(function(item) {
                    addAssociate(item);
                });

                vm.associateConfig.maintainState($scope);
                vm.associateConfig.setDirty(true);
                vm.associateConfig.nextPage();

                IhhModalItemChooser.open(vm.associateConfig);
            }
        }

        function addAssociate(associate) {
            IhhArrays.addWithNoDup(vm.glanceTemp.associates, associate);
        }

        function removeAssociate(associate) {
            for (var i = 0; i < vm.glanceTemp.associates.length; i++) {
                if (vm.glanceTemp.associates[i].id === associate.id) {
                    vm.glanceTemp.associates.splice(i, 1);
                }
            }
        }

        function isCareGroupsFeatureEnabled() {
            return vm.clinic && hasClinicFeature(vm.clinic, 'Care Groups');
        }

        /**
         * Triggers a chooser to allow selecting a care group to add to the episode.
         */
        function chooseCareGroup() {
            vm.careGroupConfig.setSuppressedItems(vm.glanceTemp.careGroups);
            vm.careGroupConfig.setGetLinkFn(undefined);
            vm.careGroupConfig.setSelectedFn(function(item) {
                vm.glanceTemp.careGroups.push(item);
            });

            vm.careGroupConfig.maintainState($scope);
            IhhModalItemChooser.open(vm.careGroupConfig);
        }

        /**
         * Removes a care group from the (being edited) episode.
         * @param {Object} careGroup the care group to remove
         */
        function removeCareGroup(careGroup) {
            for (var i = 0; i < vm.glanceTemp.careGroups.length; i++) {
                if (vm.glanceTemp.careGroups[i].id === careGroup.id) {
                    vm.glanceTemp.careGroups.splice(i, 1);
                }
            }
        }

        /**
         * Answers whether the virtual visit feature is enabled
         */
        function isVirtualVisitsFeatureEnabled() {
            return vm.clinic && hasClinicFeature(vm.clinic, 'Virtual Visits');
        }

        function getVirtualVisitsAllowed() {
            if (vm.isEdit) {
                if (angular.isUndefined(vm.glanceTemp.virtualVisitsAllowed)) {
                    vm.glanceTemp.virtualVisitsAllowed = true;
                }

                return vm.glanceTemp.virtualVisitsAllowed;
            }

            return vm.glance.virtualVisitsAllowed;
        }

        function setVirtualVisitsAllowed(value) {
            if (vm.glanceTemp.virtualVisitsAllowed !== value) {
                vm.glanceTemp.virtualVisitsAllowed = value;
                setDirty();
            }
        }

        function formatVirtualVisitsAllowed(value) {
            return value ? 'Allowed' : 'Not Allowed';
        }

        function formatEpisodeType(type) {
            return type ? type.name : "N/A";
        }

        function getEpisodeType() {
            return vm.isEdit
                    ? (vm.glanceTemp ? vm.glanceTemp.type : null)
                    : (vm.glance ? vm.glance.type : null);
        }

        function setEpisodeType(value) {
            if (vm.glanceTemp.type !== value) {
                vm.glanceTemp.type = value;
                setDirty();
            }
        }

        function getEpisodeTypes() {
            return vm.episodeTypes;
        }

        function showEpisodeType() {
            return !!getEpisodeTypes();
        }

        /**
         * Updates the isEdit value with any value passed, and returns the current value.
         *
         * @param {Boolean} val - if sent, sets the isEdit value
         * @returns {Boolean} the current value of isEdit
         */
        function isEdit (val) {
            if (val === true || val === false) {
                vm.isEdit = val;

                if (!val) {
                    setPristine();
                }
            }

            return vm.isEdit;
        }

        function setDirty () {
            if ($scope[CampaignConstants.form.campaignForm] && $scope[CampaignConstants.form.campaignGlanceForm]) {
                $scope[CampaignConstants.form.campaignForm].$setDirty();
                $scope[CampaignConstants.form.campaignGlanceForm].$setDirty();
            }
        }

        function setPristine () {
            if ($scope[CampaignConstants.form.campaignForm] && $scope[CampaignConstants.form.campaignGlanceForm]) {
                $scope[CampaignConstants.form.campaignForm].$setPristine();
                $scope[CampaignConstants.form.campaignGlanceForm].$setPristine();
            }
        }

        function cancel () {
            isEdit(false);

            vm.glanceTemp = {};
        }

        function processSave () {
            ObserverService.notifyObservers(CampaignConstants.observers.page.reset, {});
        }

        function save () {
            displayBusyIndicator();

            if (vm.glance.id) {
                // This weird assignment is because of the way episode-type-glance works on the trigger from the non-edit
                // version of the model.  Oh, well...
                vm.glanceTemp.workflowTrigger = vm.glance.workflowTrigger;

                vm.updateEpisodeTemplate(campaignId, vm.glance.id, vm.glanceTemp).then(function (result) {
                    processSave(result);
                }, function(err) {
                    RestResources.reportRestError(CampaignGlanceConstants.update.errorString, err);
                }).finally(function () {
                    hideBusyIndicator();
                });
            }
            else {
                vm.saveEpisodeTemplate(campaignId, vm.glanceTemp).then(function (result) {
                    processSave(result);
                }, function(err) {
                    RestResources.reportRestError(CampaignGlanceConstants.save.errorString, err);
                }).finally(function () {
                    hideBusyIndicator();
                });
            }
        }

        function remove () {
            displayBusyIndicator();

            Utilities.confirmDialog(CampaignConstants.episodeTemplate.remove.confirmString, function () {
                vm.removeEpisodeTemplate(campaignId, vm.glance.id).then(function () {
                    ObserverService.notifyObservers(CampaignConstants.observers.page.reset, {});
                }, function (err) {
                    RestResources.reportRestError(CampaignGlanceConstants.remove.errorString, err);
                }).finally(function () {
                    hideBusyIndicator();
                });
            }, hideBusyIndicator);
        }

        function edit () {
            vm.glanceTemp = angular.copy(vm.glance);
            vm.glanceTemp.associates = vm.glanceTemp.associates || [];
            vm.glanceTemp.therapists = vm.glanceTemp.therapists || [];
            vm.glanceTemp.careGroups = vm.glanceTemp.careGroups || [];

            var episodeTypes = getEpisodeTypes();
            if (!vm.glanceTemp.type && episodeTypes && episodeTypes.length > 0) {
                vm.glanceTemp.type = episodeTypes[0];
            }

            isEdit(true);

            setupConfirmAway();
        }

        // uses a promise to display the busy indicator
        function displayBusyIndicator () {
            EpisodeTemplateService.displayBusyIndicator();
        }

        // clears the promise so that the busy indicator will no longer be displayed
        function hideBusyIndicator () {
            EpisodeTemplateService.hideBusyIndicator();
        }

        function registerObserverCallback () {
            ObserverService.registerObserverCallback(CampaignConstants.observers.glance.edit, edit);
            ObserverService.registerObserverCallback(CampaignConstants.observers.glance.cancel, cancel);
            ObserverService.registerObserverCallback(CampaignConstants.observers.glance.save, save);
            ObserverService.registerObserverCallback(CampaignConstants.observers.glance.remove, remove);
        }

        /**
         * Does the setup necessary to create a confirmation when the user leaves the page when the form has been dirtied.
         */
        function setupConfirmAway () {
            if (isEdit() && !confirmAwaySetup) {
                var unwatchFormInit = $scope.$watch(CampaignConstants.form.campaignGlanceForm, function(theForm) {
                    if (theForm) {
                        Utilities.confirmAway($scope, theForm);
                        confirmAwaySetup = true;

                        unwatchFormInit();
                    }
                });
            }
        }
    }
})();